export default __webpack_public_path__ + "static/media/card-profile.3975f532.png";